export const environment = {
    production: false,
    envMode: 'dev',
    BASE_URL:"https://api-strategicpricing-dev.edaa.siemens-energy.cloud/",
    debugShowSettings: false,
    azuread:{
        clientId: '6a1d244c-13ab-420e-bad4-a4625416bd7c',
        authority: 'https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477',
        redirectUri: 'https://strategicpricing-dev.edaa.siemens-energy.cloud/',
        postLogoutRedirectUri: '/'
    }
};
